/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit FullScreenButton/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function FullScreenButton({
  children,
  containerId,
  viewPath = "/DesignSystem/FullScreenButton",
  onSubmit,
  isFullScreen
  
}) {
let fullScreenSubmitData = fromData.useDataSubmit({ viewPath,
context: 'full_screen',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="secondary"
 marginLeft={dtSpaceXs}
 data="full_screen"
 onClick={fullScreenSubmitData}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text={isFullScreen ? "Exit full screen" : "Full screen"}
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}